import React from 'react'
import { useSelector } from 'react-redux'

import styles from './AppSection.module.scss'
import { selectClusterList } from '../../../../store/slices/clusterListSlice'

export const AppSection: React.FC = () => {
  const clusters = useSelector(selectClusterList)

  if (clusters.length === 0) return null

  return (
    <section className={styles.Section}>
      <h2 className={styles.Title}>Магазины и бренды</h2>
      <p className={styles.Subtitle}>
        Перейдите на сайт бизнеса для прямого заказа или подробной информации
      </p>

      <div className={styles.Grid}>
        {clusters.map((c) => (
          <a
            key={c.id}
            href={`https://${c.domain}`}
            target="_blank"
            rel="noopener noreferrer"
            className={styles.Card}
          >
            <img
              src={`https://${c.domain}/icons/logo512.png`}
              alt={c.name}
              className={styles.Logo}
              loading="lazy"
            />
            <span className={styles.Name}>{c.name}</span>
          </a>
        ))}
      </div>
    </section>
  )
}